import { styled } from '@mui/material';
import VisitBackground from 'assets/images/img-cyclical-background.jpg';
import { theme } from 'assets/themes/zizzi';
import BalanceCard from 'components/BalanceCard';
import ProgressionArrow from 'assets/icons/ProgressionArrow';
import { palette } from 'assets/styles/colors';

interface CompletedProps {
  isComplete: boolean;
  tier?: number;
}

const ArrowComplete = palette.sunshine[900];

export const Wrapper = styled('div')`
  background-image: url(${VisitBackground});
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding: 2rem 1rem;

  ${theme.breakpoints.up('sm')} {
    padding: 2rem 3.5rem;
  }

  ${theme.breakpoints.up('md')} {
    border-radius: ${theme.radius.md};
  }
`;

export const VisitsBox = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const arrowSize = 30;

export const ProgressionPoint = styled(ProgressionArrow)<CompletedProps>`
  height: auto;
  margin: 0.5rem;
  width: ${arrowSize / 2}px;

  ${theme.breakpoints.up('sm')} {
    width: ${arrowSize}px;
  }

  path {
    ${({ isComplete }) => isComplete && `fill: ${ArrowComplete}`}
  }
`;

export const StyledBalanceCard = styled(BalanceCard)`
  width: 100%;
  position: relative;
  top: 60px;

  ${theme.breakpoints.up('md')} {
    width: 90%;
  }
`;
